import React from 'react';
import { motion } from 'framer-motion';
export const Problem = () => {
  return <section className="py-24 bg-wellness-forest text-wellness-cream relative overflow-hidden" data-id="element-106">
      {/* Subtle botanical motif background */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none" data-id="element-107">
        <svg viewBox="0 0 100 100" preserveAspectRatio="none" className="w-full h-full" data-id="element-108">
          <path d="M0,0 C30,40 70,60 100,100 L0,100 Z" fill="currentColor" data-id="element-109" />
        </svg>
      </div>

      <div className="container mx-auto px-6 max-w-4xl relative z-10" data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-111">
          <h2 className="text-4xl md:text-5xl lg:text-6xl mb-8 leading-tight" data-id="element-112">
            The "Eat Less, Move More" Mantra is{' '}
            <span className="italic text-wellness-gold" data-id="element-113">
              Making You Fatter.
            </span>
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="space-y-8 text-lg md:text-xl font-light font-sans leading-relaxed text-wellness-cream/90" data-id="element-114">
          <p data-id="element-115">
            If you are over 35, the fitness industry is trying to fix a hormonal
            problem with a caloric solution.
          </p>
          <p data-id="element-116">
            When you push through an intense HIIT class or skip breakfast to
            "save calories," your aging adrenals perceive a crisis. They dump
            cortisol into your system, which sends a frantic signal to your
            brain:{' '}
            <strong className="font-medium text-wellness-gold" data-id="element-117">
              Store every ounce of energy as fat around the vital organs.
            </strong>
          </p>
          <p className="text-2xl md:text-3xl font-serif text-center py-8 text-wellness-cream italic" data-id="element-118">
            "Your 'menopause belly' isn't a sign of laziness; it's a survival
            mechanism triggered by a body that feels under attack."
          </p>
        </motion.div>
      </div>
    </section>;
};